import { render, staticRenderFns } from "./FormLinkIcon.vue?vue&type=template&id=6fa7de64&"
import script from "./FormLinkIcon.vue?vue&type=script&lang=js&"
export * from "./FormLinkIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports